import PropTypes from 'prop-types';
import * as analytics from 'Utils/analytics';
import { filterInterests } from 'Services/interests';
import MediaRail from 'Components/profile/MediaRail';
const { EVENTS } = analytics;

const RecommendationsList = (props) => {
  const { onFavoriteRecommendation, ...rest } = props;
  const handleItemClick = (id) => {
    const analyticsEvent = props.interestsBased
      ? EVENTS.selectInterestsRecommendationsItem
      : EVENTS.selectRecommendationsItem;
    analytics.event({ action: analyticsEvent, label: id });
  };
  const getLabel = (type) => {
    if (props.interestsBased) {
      const { name } = filterInterests('programming')[type];
      return props.strings.interestsRecommendationsHeadingVariable.formatUimTranslation(
        name
      );
    }
    return props.strings.recommendations;
  };

  return (
    <div className="recommendations-list">
      <div className="row__label">{getLabel(props.type)}</div>
      <MediaRail
        {...rest}
        onItemActionClick={onFavoriteRecommendation}
        onItemClick={handleItemClick}
      />
    </div>
  );
};

RecommendationsList.propTypes = {
  country: PropTypes.string.isRequired,
  hasError: PropTypes.bool.isRequired,
  interestsBased: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  itemList: PropTypes.array.isRequired,
  itemMap: PropTypes.object.isRequired,
  onFavoriteRecommendation: PropTypes.func.isRequired,
  strings: PropTypes.object.isRequired,
  totalCount: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
};

RecommendationsList.defaultProps = {
  interestsBased: false,
};

export default RecommendationsList;
